export default [
	{
		featureType: "poi.attraction",
		elementType: "all",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "poi.business",
		elementType: "all",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "poi.government",
		elementType: "all",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "poi.medical",
		elementType: "all",
		stylers: [
			{
				visibility: "on"
			}
		]
	},
	{
		featureType: "poi.place_of_worship",
		elementType: "all",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "poi.school",
		elementType: "all",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "poi.sports_complex",
		elementType: "all",
		stylers: [
			{
				visibility: "off"
			}
		]
	}
];
